// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Contexto para controlar el polling global de la aplicación.
 * Escucha 'archat-logout' para pausar polling al cerrar sesión.
 */

import { createContext, useContext, useState, useEffect } from 'react';

const PollingContext = createContext();

export const usePolling = () => {
  const context = useContext(PollingContext);
  // Si no hay contexto, devolver valores por defecto (polling activo)
  if (!context) {
    console.warn('usePolling usado fuera de PollingProvider, usando valores por defecto');
    return { isPaused: false, pausePolling: () => {}, resumePolling: () => {} };
  }
  return context;
};

export const PollingProvider = ({ children }) => {
  const [isPaused, setIsPaused] = useState(false);

  const pausePolling = () => {
    setIsPaused(true);
  };

  const resumePolling = () => {
    setIsPaused(false);
  };

  useEffect(() => {
    const handler = () => {
      pausePolling();
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('archat-logout', handler);
      return () => window.removeEventListener('archat-logout', handler);
    }
  }, []);

  return (
    <PollingContext.Provider value={{ isPaused, pausePolling, resumePolling }}>
      {children}
    </PollingContext.Provider>
  );
};

